import { render, staticRenderFns } from "./ValidateForgotPasswordCode.vue?vue&type=template&id=67f160b2"
import script from "./ValidateForgotPasswordCode.vue?vue&type=script&lang=js"
export * from "./ValidateForgotPasswordCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports